import(/* webpackMode: "eager", webpackExports: ["WorkCaseStudyClient"] */ "/vercel/path0/app/work/[slug]/work-client.tsx");
